import { useRef, useState } from "react";
import { ChevronsUp, Eye } from "lucide-react";
import { vibrate } from "../ui";

const MAX = 320;
const THRESHOLD = 110;

export default function RevealCard({ player, onSeen, play }) {
  const [dy, setDy] = useState(0);
  const [dragging, setDragging] = useState(false);
  const [open, setOpen] = useState(false);
  const startY = useRef(0);

  const hide = () => {
    setOpen(false);
    onSeen();
  };

  const down = (e) => {
    e.currentTarget.setPointerCapture(e.pointerId);
    startY.current = e.clientY;
    setDragging(true);
  };

  const move = (e) => {
    if (!dragging) return;
    let d = e.clientY - startY.current;
    if (d > 0) d *= 0.25;
    if (d < -MAX) d = -MAX + (d + MAX) * 0.2;
    setDy(d);
    if (!open && d < -THRESHOLD) {
      setOpen(true);
      vibrate(35);
      play("reveal");
    } else if (open && d > -THRESHOLD * 0.5) {
      hide();
    }
  };

  const up = () => {
    setDragging(false);
    setDy(0);
    if (open) hide();
  };

  return (
    <div className="reveal-stage" data-testid="reveal-stage">
      <div className={`secret role-${player.role}${open ? " show" : ""}`} data-testid="secret-panel">
        {open && (
          <div className="secret-inner">
            <span className="secret-role" data-testid="secret-role">{player.role === "impostor" ? "Eres el IMPOSTOR" : "Eres INOCENTE"}</span>
            {player.word ? (
              <>
                <span className="secret-label">Tu palabra</span>
                <span className="secret-word" data-testid="secret-word">{player.word}</span>
              </>
            ) : (
              <span className="secret-word small" data-testid="secret-word">Sin palabra. ¡Disimula!</span>
            )}
          </div>
        )}
      </div>
      <div
        className={`cover glass${dragging ? " dragging" : ""}`}
        style={{ transform: `translateY(${dy}px) rotate(${dy * 0.015}deg)` }}
        onPointerDown={down}
        onPointerMove={move}
        onPointerUp={up}
        onPointerCancel={up}
        data-testid="reveal-card"
      >
        <Eye size={34} className="cover-eye" />
        <span className="cover-name">{player.name}</span>
        <span className="cover-hint"><ChevronsUp size={22} className="bob" /> Desliza hacia arriba y mantén</span>
      </div>
    </div>
  );
}
